// extracted by mini-css-extract-plugin
module.exports = {"Bg":"style_Bg__3P6KN","BgImg":"style_BgImg__mAbA6","Slogan":"style_Slogan__zJrwf","SloganChinese":"style_SloganChinese__1Y31m","SloganEnglish":"style_SloganEnglish__3UvbB"};